"use client";
import React, { useEffect, useState } from "react";
import  "./page.scss";

import Contact from "@/components/home/contact";
import Hero from "@/components/home/hero";
import EnhanceImage from "@/components/home/enhanceImage";
import AiFaceSwap from "@/components/home/aiFaceSwap";
import AiImageGenerator from "@/components/home/aiImageGenerator";
import InstantFaceSwap from "@/components/home/instantFaceSwap";
import Blogs from "@/components/home/blogs";
import UpgradeNowModal from "@/components/modals/upgradeNow";
import { useSelector } from "react-redux";

export default function HomePage() {
  const userDataSelector = useSelector((data) => data.userData.user);
  const [contact, setContact] = useState();
  const [openUpgradeNowModal, setOpenUpgradeNowModal] = useState(false);
  const [targetElement, setTargetElement] = useState("");
  const [currentFreeImgsStatus, setCurrentFreeImgsStatus] = useState(0);
  // checking freeImgsStatus
  useEffect(() => {
    const freeImgsStatus = Number(localStorage.getItem("freeImgsStatus")) || 0;
    setCurrentFreeImgsStatus(freeImgsStatus);
  }, []);

  useEffect(() => {
    if (!targetElement) return;

    // Check if the popup has been shown in the current session
    const hasSeenPopup = sessionStorage.getItem("hasSeenUpgradePopup");

    // Free and Premium user conditions
    const freeFaceSwapImagesLeft =
      userDataSelector?.freeCreditsHistory?.faceSwap || 0;
    const freeImageEnhancerImagesLeft =
      userDataSelector?.freeCreditsHistory?.enhancer || 0;
    const freeImageGeneratorImagesLeft =
      userDataSelector?.freeCreditsHistory?.generator || 0;

    const isAnyProductDonotHaveFreeImagesLeft =
      freeFaceSwapImagesLeft === 0 ||
      freeImageEnhancerImagesLeft === 0 ||
      freeImageGeneratorImagesLeft === 0;

    const isLoggedOutUser = !userDataSelector;

    const freeUserWhoDonotHaveFreeImagesLeft =
      userDataSelector?.creditType === "FREE" &&
      isAnyProductDonotHaveFreeImagesLeft;

    const premiumUserWhoDonotHaveCredits =
      userDataSelector?.creditType === "PREMIUM" &&
      userDataSelector?.credits === 0;

    // Ensure conditions are met
    if (
      hasSeenPopup ||
      (!isLoggedOutUser &&
        !freeUserWhoDonotHaveFreeImagesLeft &&
        !premiumUserWhoDonotHaveCredits)
    ) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setOpenUpgradeNowModal(true);
          sessionStorage.setItem("hasSeenUpgradePopup", "true");
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        threshold: 1,
      }
    );

    observer.observe(targetElement);

    // Cleanup observer on unmount or dependency changes
    return () => observer.disconnect();
  }, [targetElement, currentFreeImgsStatus, userDataSelector]);

  return (
    <div className="HomePage">
      {/* hero */}
      <Hero />

      {/* ai-face-swap*/}
      <AiFaceSwap />

      {/* enhance-image */}
      <EnhanceImage setTargetElement={setTargetElement} />

      {/* ai-image-generator */}
      <AiImageGenerator />

      {/* instant-face-swap */}
      <InstantFaceSwap />

      <Blogs />

      {/* contact */}
      <div id="contact">
        <Contact setContact={setContact} />
      </div>

      {/* <div
        data-aos="fade-up"
        data-aos-delay={200}
        style={{
          height: "20vw",
          opacity: 1,
        }}
      >
        Hi how are you ?
      </div> */}

      {/* upgrade now modal */}
      {openUpgradeNowModal && (
        <UpgradeNowModal
          setOpenUpgradeNowModal={setOpenUpgradeNowModal}
          userDataSelector={userDataSelector}
        />
      )}
    </div>
  );
}
